import angular from "angular";

let mod = angular
    .module('BookingModule.NotElRegRoutes', [])
    .component('notElRegRoutes', {
        controller: [controller],
        template: require('./not-el-reg-routes.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.routes = $ctrl.resolve.routes;
    };

    $ctrl.continueBook = function () {
        $ctrl.close();
    };
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/not-el-reg-routes/not-el-reg-routes.js